"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var CollectionFilters = /*#__PURE__*/function (_window$AbstractEleme) {
    _inherits(CollectionFilters, _window$AbstractEleme);

    var _super = _createSuper(CollectionFilters);

    function CollectionFilters(id, options) {
      _classCallCheck(this, CollectionFilters);

      $.extend(true, options, {
        watchResize: true
        /*,
                        scrollWatcher: {
                            thresholdStep: 2
                        }*/

      });
      return _super.call(this, id, options);
    }

    _createClass(CollectionFilters, [{
      key: "init",
      value: function init() {
        this.$window = $(window);
        this.$filtersList = this.$domElement.find(".filters-content__list");
        $(document).on("scroll." + this.id, this.setFiltersHeight.bind(this));
        this.$window.off("bcsffilter_buildadditionalelements." + this.id);
        this.$window.on("bcsffilter_buildadditionalelements." + this.id, this.onFiltersUpdate.bind(this));

        _get(_getPrototypeOf(CollectionFilters.prototype), "init", this).call(this);
      } // get scrollWatcherViewportState() {
      //     return this.scrollWatcher.viewportState;
      // }

    }, {
      key: "onToggle",
      value: function onToggle() {//  Probably overridden by parent class;
      }
    }, {
      key: "setFiltersHeight",
      value: function setFiltersHeight() {
        if (window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.XL)) {
          var TOP = window.Math.max(this.$filtersList.offset().top - this.$window.scrollTop(), parseInt(this.$domElement.css("top"), 10));
          this.$filtersList.css("max-height", this.$window.height() - TOP - 2);
        } else {
          this.$filtersList.css("max-height", "");
        }
      }
    }, {
      key: "resizeHandler",
      value: function resizeHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.setFiltersHeight();
      }
    }, {
      key: "onFiltersUpdate",
      value: function onFiltersUpdate(event) {
        this.setFiltersHeight();
      }
    }, {
      key: "dispose",
      value: function dispose() {
        $(document).off("scroll." + this.id);
        this.$window.off("bcsffilter_buildadditionalelements");

        _get(_getPrototypeOf(CollectionFilters.prototype), "dispose", this).call(this);
      }
    }, {
      key: "isOpen",
      get: function get() {
        return;
      }
    }]);

    return CollectionFilters;
  }(window.AbstractElement);

  window.CollectionFilters = CollectionFilters;
})(window);
